'use strict';

angular
    .module('directives.userRequests')
    .controller('userRequestStartedActionsController', 
                ['$scope', '$state', 'selfAccessRequestService', 
        function ($scope, $state, selfAccessRequestService) {

            // Get Arrival Snow Location URL
            if ($scope.model.IsArrivalRequest) {
                selfAccessRequestService
                    .getSelfAccessRequestWithSNOWParams($scope.model.UserAccessRequestID)
                    .then(function (reqWithSNOWParams) {
                        $scope.reqWithSNOWParams = reqWithSNOWParams;
                    });
            }
           

    }]);